import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type TireInstallation } from 'types/tire-installation.types';
import { type RootState } from './index';

export interface TireInstallationState {
  tireInstallations: TireInstallation[];
  isLoading: boolean;
  isLoaded: boolean;
  total: number;
  totalPages: number;
}

const initialState: TireInstallationState = {
  tireInstallations: [],
  isLoading: false,
  isLoaded: false,
  total: 0,
  totalPages: 0,
};

export const tireInstallationSlice = createSlice({
  name: 'tireInstallation',
  initialState,
  reducers: {
    setTireInstallations: (
      state,
      action: PayloadAction<
        | TireInstallation[]
        | { data: TireInstallation[]; total: number; totalPages: number }
      >
    ) => {
      if (Array.isArray(action.payload)) {
        state.tireInstallations = action.payload;
        state.total = action.payload.length;
        state.totalPages = 1;
      } else {
        state.tireInstallations = action.payload.data;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
      }
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    resetTireInstallations: (state) => {
      state.tireInstallations = [];
      state.isLoading = false;
      state.isLoaded = false;
      state.total = 0;
      state.totalPages = 0;
    },
  },
});

export const {
  setTireInstallations,
  setIsLoading,
  setIsLoaded,
  resetTireInstallations,
} = tireInstallationSlice.actions;

export const selectTireInstallation = (state: RootState) =>
  state.tireInstallationReducer;

export default tireInstallationSlice.reducer;
